import { SupplementKnowledgeDetailResponse } from 'services/api/supplementKnowledge';
import { Tabs } from 'antd';
import { useTranslate } from '@tolgee/react';
import { Section } from './Section';
import { Answer } from './Answer';

interface Props {
  source?: SupplementKnowledge.Source;
  dataSource: SupplementKnowledgeDetailResponse;
}

export const AnswerPanel = (props: Props) => {
  const { source, dataSource } = props;
  const { timeLines, supplementalKnowledgeValue, submittedUserName } = dataSource;
  const { answer, answers, originAnswers } = supplementalKnowledgeValue;
  const { t } = useTranslate();
  // 是否有修改过回复内容
  const isModifyAnswer = timeLines.some((item) => item.operationType === 'UPDATE_ANSWER');

  if (isModifyAnswer) {
    return (
      <Tabs size="small" className="!px-4 flex-grow-0 flex-shrink-0 flex flex-col overflow-hidden">
        <Tabs.TabPane key="answer" tab={t('主管调整后答案')}>
          <Answer answers={answers} userName={submittedUserName} />
        </Tabs.TabPane>
        <Tabs.TabPane
          key="modify"
          tab={t(source === 'HISTORY_CUSTOMER' ? '标注答案' : '客服提交答案')}
        >
          <Answer answers={originAnswers} userName={submittedUserName} />
        </Tabs.TabPane>
      </Tabs>
    );
  }

  const submitAnswers = originAnswers?.length > 0 ? originAnswers : answer ? [answer] : [];

  return (
    <Section title={t(source === 'HISTORY_CUSTOMER' ? '标注答案' : '客服提交答案')}>
      <Answer answers={submitAnswers} userName={submittedUserName} />
    </Section>
  );
};
